import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  TopBar,
  Nav,
  MobileNav,
  Footer,
  CookieConsent,
  AgeGate,
} from "@/components/organisms";

declare const __BUILD_VERSION__: string;

// App shell: announcement bar + nav + page outlet + footer. Also hosts the Console Version
// Beacon and scroll-to-top-on-navigation.
export function RootLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    const version =
      typeof __BUILD_VERSION__ !== "undefined" ? __BUILD_VERSION__ : "DEV";
    console.log(
      `%c [DEPLOYMENT VERIFIED] Build: ${version} `,
      "background: #00374b; color: #86bb41; font-weight: bold; border: 1px solid #86bb41; padding: 2px 6px;",
    );
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const isAdmin = pathname.startsWith("/admin");

  return (
    <div className="flex min-h-screen flex-col bg-white">
      {!isAdmin && <TopBar />}
      {!isAdmin && <Nav />}
      {!isAdmin && <MobileNav />}
      <main className="flex-1">
        <Outlet />
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <CookieConsent />}
      {/*
        DRB-4 — 21+ gate. Storefront only: an admin signing in to fulfil orders is not a shopper,
        and gating /admin would put the interstitial between Dr. Burns and her own back office.
        Renders last so it stacks above everything, including the cookie banner.
      */}
      {!isAdmin && <AgeGate />}
    </div>
  );
}
